import { createFileRoute, redirect } from '@tanstack/react-router';

import { CkDebug } from '@/features/ck-debug/ck-debug';
import { useCkDebugPageSetup } from '@/features/ck-debug/ck-debug.hooks';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/ck-debug/')({
  beforeLoad() {
    if (userStore.isInternalUser) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  useCkDebugPageSetup();

  return <CkDebug />;
}
